/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ActionCanvas = zod.record(zod.string(), zod.unknown());

export type ActionCanvas = zod.input<typeof ActionCanvas>;
export type ActionCanvasOutput = zod.output<typeof ActionCanvas>;
